import { combineReducers } from 'redux';
import authReducers from './authReducers';
import condominiumReducer from './condominiumReducer';
import propertyReducer from './propertyReducer';

export default combineReducers({
    auth: authReducers,
    condominium: condominiumReducer,
    property: propertyReducer
});